import { pageFactory } from '../../support';

export const VisualizationTab = pageFactory({
  url: '',
  selectors: {
    xAxisSection: 'X-Axis section',
  },
});
